


























































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../general/OnscreenMenu.vue";
import RentalAccountDetails from "./RentalAccountDetails.vue";

import RentalAccountJson from "../../shared/RentalAccountJson";
import CustomerJson from "../../shared/CustomerJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

import GeneralInfos from "../custom/GeneralInfos";

export default Vue.extend({
  name: "RentalAccounts",
  components: {
    Loading,
    OnscreenMenu,
    TableView,
    RentalAccountDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      GeneralInfos: GeneralInfos,
      showDetails: false,
      detailsMode: "read",
      allAccounts: null as RentalAccountJson[] | null,
      selectedProductId: null as number | null,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: RentalAccountJson | null, mode: string) {
      if (item != null) {
        this.selectedProductId = item.ID;
      } else {
        this.selectedProductId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },
    /*** END: details view ***/

    loadData() {
      this.loadAllAccounts();
    },

    async loadAllAccounts() {
      this.allAccounts = null;
      this.selectedProductId = null;

      if (this.restClient != null) {
        try {
          this.allAccounts = await this.restClient.getRentalAccounts();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async reloadData() {
      this.loadAllAccounts();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    accountColumns: function (): TableViewColumnDefinitions<RentalAccountJson>[] {
      let vue = this;

      return [
        {
          th: "Vorname",
          td: (i) => i.customer.guardianFirstName,
        },
        {
          th: "Nachname",
          td: (i) => i.customer.guardianLastName,
        },
        {
          th: "Kategorie",
          td: (i) => i.type,
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<RentalAccountJson>[];
    },
  },
});
